import React from "react";
import { ArrowRight, Shield, Sparkles, BookOpen } from "lucide-react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#fffaf5]">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#fffaf5] via-[#fdf2f4] to-[#fffaf5]" />
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#f7e8e4] rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#b89a6d]/20 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-32 pb-20">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#fdf2f4] border border-[#e8c5b8] rounded-full mb-8">
          <Shield className="w-4 h-4 text-[#b89a6d]" />
          <span className="text-sm text-[#b89a6d] font-medium">Med Spa & Aesthetic Wellness Storefront</span>
        </div>

        {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl font-bold text-[#3a2a26] mb-6 leading-tight">
          Research Peptides for
          <span className="block bg-gradient-to-r from-[#d4a5ad] to-[#b89a6d] bg-clip-text text-transparent">
            Med Spa & Aesthetic Wellness
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-xl text-[#7a6b62] max-w-3xl mx-auto mb-8 leading-relaxed hero-description">
          A curated catalog and plain-English education on peptides studied in
          anti-aging, longevity, recovery, and wellness research — with transparent labeling.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <Link to="/shop">
            <Button className="bg-[#d4a5ad] hover:bg-[#c4949c] text-white font-semibold px-8 py-6 text-lg group">
              Explore the Catalog
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
            </Button>
          </Link>
          <Link to="/blog">
            <Button
              variant="outline"
              className="border-[#d4a5ad] text-[#b89a6d] hover:bg-[#fdf2f4] px-8 py-6 text-lg"
            >
              <BookOpen className="mr-2 w-5 h-5" />
              Read the Research
            </Button>
          </Link>
        </div>

        {/* Disclaimer */}
        <div className="bg-white/80 border border-[#f0d8d4] rounded-xl px-6 py-4 max-w-2xl mx-auto disclaimer">
          <p className="text-sm text-[#7a6b62]">
            <span className="text-[#b89a6d] font-medium">Educational storefront for med spa &amp; aesthetic research peptides.</span>{" "}
            Not medical advice. Products are research chemicals for laboratory use only.
          </p>
        </div>

        {/* Feature Icons */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 max-w-4xl mx-auto">
          <div className="bg-white/80 backdrop-blur-sm border border-[#f0d8d4] rounded-xl p-6">
            <Sparkles className="w-8 h-8 text-[#b89a6d] mx-auto mb-3" />
            <div className="text-lg font-semibold text-[#3a2a26] mb-1">Anti-Aging & Skin</div>
            <div className="text-[#7a6b62] text-sm">GHK-Cu, Glutathione, NAD+</div>
          </div>
          <div className="bg-white/80 backdrop-blur-sm border border-[#f0d8d4] rounded-xl p-6">
            <Shield className="w-8 h-8 text-[#b89a6d] mx-auto mb-3" />
            <div className="text-lg font-semibold text-[#3a2a26] mb-1">Transparent Labels</div>
            <div className="text-[#7a6b62] text-sm">Clear research-grade specs</div>
          </div>
          <div className="bg-white/80 backdrop-blur-sm border border-[#f0d8d4] rounded-xl p-6">
            <BookOpen className="w-8 h-8 text-[#b89a6d] mx-auto mb-3" />
            <div className="text-lg font-semibold text-[#3a2a26] mb-1">Plain-English Science</div>
            <div className="text-[#7a6b62] text-sm">Evidence-led education</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
